import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectConversationScopeVersion } from '../../state/aiSidekickChatSlice';
import {
  closeResetConfirm,
  selectIsResetConfirmLoading,
  selectIsResetConfirmOpen,
} from '../../state/aiSidekickSlice';

type ComposerDraftGuard = {
  composerKey: number;
  hasComposerDraft: boolean;
  handleComposerValueChange: (value: string) => void;
};

/** Tracks whether the active conversation has an unsent composer draft. */
export const useComposerDraftGuard = (): ComposerDraftGuard => {
  const dispatch = useDispatch();
  const conversationScopeVersion = useSelector(selectConversationScopeVersion);
  const isResetConfirmOpen = useSelector(selectIsResetConfirmOpen);
  const isResetConfirmLoading = useSelector(selectIsResetConfirmLoading);
  const composerKey = conversationScopeVersion;
  const [draftComposerKey, setDraftComposerKey] = useState<number | null>(null);

  const handleComposerValueChange = useCallback(
    (value: string) => {
      setDraftComposerKey(value.length === 0 ? null : composerKey);
      if (value.length > 0 && isResetConfirmOpen && !isResetConfirmLoading) {
        dispatch(closeResetConfirm());
      }
    },
    [composerKey, dispatch, isResetConfirmLoading, isResetConfirmOpen]
  );

  return {
    composerKey,
    hasComposerDraft: draftComposerKey === composerKey,
    handleComposerValueChange,
  };
};
